type Motion = typeof import("./motion");
let motionRequest: Promise<Motion | undefined> | undefined;

/** Warm and prepare native keyframes once; reduced motion keeps the static pose. */
export function preloadChatActionMotion(): Promise<Motion | undefined> {
  if (
    typeof window === "undefined" ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return Promise.resolve(undefined);
  }
  motionRequest ??= loadMotion().catch(() => {
    motionRequest = undefined;
    return undefined;
  });
  return motionRequest.then((motion) => {
    motion?.prepareOrbMotion();
    return motion;
  });
}

async function loadMotion(): Promise<Motion> {
  return import("./motion");
}
